<div class="minor-account-invite-sent">
  <div class="minor-account-invite-sent-icon">
    <se-fe-icon
      seFeDataName="spot_invite_success"
      seFeDataSize="950"
      seFeDataAriaLabel="envelope"
      [seFeDataMargin]="false"
    ></se-fe-icon>
  </div>
  <div class="minor-account-invite-sent-title">
    <se-po-highlight-label
      label="Invite sent!"
    ></se-po-highlight-label>
  </div>
  <div>
    <p>Your part's all done. Now it's your parent's turn to finish transferring your account.</p>
    <p>Thank you for helping to keep sports safe and secure for kids!</p>
  </div>
</div>
